
<template>
  <div>
    <index-card fluid>
      <template slot="header">
        <v-row>
          <v-col class="white--text d-flex justify-space-between align-center headline">
            <div>
              <v-btn icon color="blue-grey darken-1" :to="{name: 'Home'}"><v-icon color="white">mdi-arrow-left</v-icon></v-btn>
              <v-btn class="ml-2" color="white black--text" @click="dialog_new_pix = true"><v-icon left>mdi-plus</v-icon>Pix</v-btn>
              <v-btn class="ml-2" color="white black--text" @click="dialog_new_pix_cobranca = true"><v-icon left>mdi-plus</v-icon>PIX Cobrança</v-btn>
            </div>
            <span>Pix</span>
            <div class="d-flex">
              <BtnExportCsvAndPDF 
                api_model="Pix" 
                action="Pixes"
                :filters="filters" 
                class="mx-3"
              ></BtnExportCsvAndPDF>
              <v-icon color="white" @click="getPix()">mdi-refresh</v-icon>
            </div>
          </v-col>
        </v-row>
      </template>
      <template slot="data_table">
        <v-card>
          <v-card-text>
            <filter-data
              with_client_portfolios
              :months_before="1"
              :months_after="1"
              :loading_block="loading"
              @doneFilter="handleDoneFilter"
              with_pix_status
              with_places
            />

            <v-row justify="center" class="mt-4 mb-5">
              <v-col cols='5'>
                <v-card style="border-radius:12px">
                  <v-card-text class="px-2 py-1">
                    <v-row align="center" class="px-5 py-2" justify="center">
                        <v-icon class="mr-5" color='blue-grey darken-3'>mdi-currency-usd</v-icon>
                        <span class="title">{{ total_value.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) }}</span>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>

              <v-col cols='5'>
                <v-card style="border-radius:12px">
                  <v-card-text class="px-2 py-1">
                    <v-row align="center" class="px-5 py-2" justify="center">
                        <v-icon class="mr-5" color='blue-grey darken-3'>mdi-qrcode</v-icon>
                        <span class="title">{{ total_pix }} Pix</span>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
              
            </v-row>

            <card-loading-transparent class="mt-8 pt-8 pb-5" v-if="loading"></card-loading-transparent>
            
            <div>
              <v-data-table v-if="all_pix != null"
                ref="table"
                mobile-breakpoint="1"
                :headers="headers"
                :items="all_pix"
                class="elevation-0"
                :options.sync="pagination"
                :server-items-length="total_pix"
                :loading="loading"
                :footer-props="{itemsPerPageOptions: [10, 30, 50, 100]}"
              >
      
                <template v-slot:item.created_at="{item}">{{ $moment(item.created_at).format('DD/MM/YYYY HH:mm') }}</template>
                <template v-slot:item.due_date="{item}">{{
                  item.due_date ? $moment(item.due_date).format('DD/MM/YYYY HH:mm') :
                    'Instantâneo'
                }}</template>
                <template v-slot:item.payment_date="{item}">{{
                  item.payment_date && $moment(item.payment_date).format('DD/MM/YYYY HH:mm') || '---'
                }}</template>
                <template v-slot:item.total_amount="{item}">{{
                  Number(item.total_amount).toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL'
                  })}}
                  <dialog-pix-big-value-details v-if="Number(item.total_amount) >= 3000" :item="item"></dialog-pix-big-value-details>
                </template>
                <template v-slot:item.pix_origin="{item}">
                  <v-chip small outlined :color="origins_map[item.pix_origin]?.color || 'blue-grey'">
                    {{ origins_map[item.pix_origin]?.text || '--' }}
                  </v-chip>
                </template>
                <template v-slot:item.company_key="{item}">{{ comp_keys_map[item.company_key] || item.company_key }}</template>
                <template v-slot:item.solution="{item}">{{ solution_map[item.solution] || '--' }}</template>
                <template v-slot:item.pix_status="{item}">
                  <v-chip dark :color="mapColor(item)" small>
                    <v-avatar left>
                      <v-icon small>{{ mapIcon(item) }}</v-icon>
                    </v-avatar>
                    {{ item.pix_status ? statuses_map[item.pix_status]?.text : '-' }}
                  </v-chip>
                </template>
                <template v-slot:item.actions="{item}">
                    <v-tooltip top color="black">
                      <template v-slot:activator="{ on }">
                        <v-btn v-on="on" text icon color="primary" class='ma-1' small
                          :disabled="loading || !['pending', 'pendingv'].includes(item.pix_status)"
                          @click="sharePixUrl(item)"><v-icon small>mdi-open-in-new</v-icon></v-btn>
                      </template>
                      Compartilhar com cliente
                    </v-tooltip>
      
      
                    <v-tooltip top color="black" v-if='false'>
                      <template v-slot:activator="{ on }">
                        <v-btn v-on="on" text icon color="primary" class='ma-1' small
                          :disabled="loading || !['pending', 'pendingv'].includes(item.pix_status)"
                          @click="showPix(item)"><v-icon>print</v-icon></v-btn>
                      </template>
                      Imprimir
                    </v-tooltip>
      
                    <v-tooltip top color="black" v-if="false">
                      <template v-slot:activator="{ on }">
                        <v-btn v-on="on" text icon color="primary" class='ma-1' small
                          :disabled="loading || !['pending', 'pendingv'].includes(item.pix_status)"
                          @click="pixCopy(item)"><v-icon small>mdi-content-paste</v-icon></v-btn>
                      </template>
                      Pix copia e cola
                    </v-tooltip>
      
                    <v-tooltip top color="black">
                      <template v-slot:activator="{ on }">
                        <v-btn v-on="on" text icon color="primary" class='ma-1' small
                          :disabled="loading || !['pending', 'pendingv'].includes(item.pix_status)"
                          @click="pixDialog(item)"><v-icon small>mdi-qrcode</v-icon></v-btn>
                      </template>
                      QrCode
                    </v-tooltip>
      
                    <v-tooltip top color="black" v-if="false && item.pix_status == 'approved'">
                      <template v-slot:activator="{ on }">
                        <v-btn v-on="on" text icon color="primary" class='ma-1' small :disabled="loading"
                          @click="refundPix(item)"><v-icon small>mdi-swap-horizontal</v-icon></v-btn>
                      </template>
                      Estornar
                    </v-tooltip>

                    <v-tooltip top color="black" v-if="['pending', 'pendingv'].includes(item.pix_status)">
                      <template v-slot:activator="{ on }">
                        <v-btn v-on="on" text icon color="primary" class='ma-1' small :disabled="loading"
                          @click="verifyPix(item)"><v-icon small>mdi-check-network-outline</v-icon></v-btn>
                      </template>
                      Verificar
                    </v-tooltip>


                    <v-tooltip top color="black" v-if="['pending', 'pendingv'].includes(item.pix_status)">
                      <template v-slot:activator="{ on }">
                        <v-btn v-on="on" text icon color="primary" class='ma-1' small :disabled="loading"
                          @click="cancelPix(item)"><v-icon small>mdi-cancel</v-icon></v-btn>
                      </template>
                      Cancelar
                    </v-tooltip>



                </template>
                <template v-slot:no-data>
                  <v-alert :value="true" type="info" icon="mdi-information">
                    Não existem pix nesse período.
                  </v-alert>
        
                </template>
                <template v-slot:no-results>
                  <v-alert :value="true" type="error" icon="mdi-alert">
                    Não foi possível encontrar "{{ search }}" nos pix.
                  </v-alert>
        
                </template>
              </v-data-table>
            </div>
          </v-card-text>
        </v-card>
      </template>
    </index-card>

    <dialog-loading v-if="saving || verifying" :loadingText="saving ? 'Salvando' : 'Verificando'"></dialog-loading>
    <dialog-pix v-if="dialog_pix.show" :item="dialog_pix" @close="closePixDialog"></dialog-pix>
    <dialog-new-pix-cobranca
      v-if="dialog_new_pix_cobranca"
      @close="dialog_new_pix_cobranca = false"
      @doneNewPixCobranca="handleDoneNewPixCobranca"
    ></dialog-new-pix-cobranca>
    <router-view></router-view>
    <create-pix
      v-if="dialog_new_pix"
      @done="getPix()"
      @close="dialog_new_pix = false"
    ></create-pix>
  </div>
</template>

<script>
import Api from '@/api/index'
import FilterData from '@/components/shared/FilterData.vue'
import DialogPix from './DialogPix.vue'
import SolutionMap from '@/_backoffice/_registrations/mixins/solution_map.js'
import DialogPixBigValueDetails from './DialogPixBigValueDetails.vue'
import gateway_keys from './GatewayKeys'

export default {
  name: 'AllPix',
  mixins: [SolutionMap],
  components: { 
    FilterData, 
    DialogPix, 
    DialogPixBigValueDetails,
    DialogNewPixCobranca: () => import('./DialogNewPixCobranca.vue'),
    CreatePix: () => import('./CreatePix.vue'),
    BtnExportCsvAndPDF: () => import('@/components/data_export/BtnCreateDataExport.vue'),
    IndexCard: () => import("@/_backoffice/_registrations/components/shared/index/IndexCard.vue"),
   },
  data() {
    return {
      loading: false,
      filters:{},
      total_value: 0,
      dialog_new_pix_cobranca: false,
      dialog_new_pix: false,

      total_pix: 0,
      pagination: {
        page:1,
        itemsPerPage: 15,
        sortBy:['id'],
        sortDesc:[true],
        groupBy:[],
        groupDesc:[],
        mustSort:false,
        multiSort:false,
      },

      search: null,

      refetch_interval: null,

      all_pix: [],

      statuses_map: {
        pending: {
          text: 'Pendente',
          color: 'amber',
          icon: 'mdi-clock',
        },
        pendingv: {
          text: 'Pendente',
          color: 'amber',
          icon: 'mdi-clock',
        },
        accounted: {
          text: 'Accounted',
          color: 'amber',
          icon: 'mdi-clock',
        },
        approved: {
          text: 'Pago',
          color: 'success',
          icon: 'mdi-check-circle',
        },
        expired: {
          text: 'Expirado',
          color: 'error',
          icon: 'mdi-exclamation',
        },
        cancelled: {
          text: 'Cancelado',
          color: 'blue-grey',
          icon: 'mdi-cancel',
        },
        partial_refunded: {
          text: 'Estornado parcial',
          color: 'blue-grey',
          icon: 'mdi-swap-horizontal',
        },
        refunded: {
          text: 'Estornado',
          color: 'blue-grey',
          icon: 'mdi-swap-horizontal',
        },
        error: {
          text: 'Erro',
          color: 'error',
          icon: 'mdi-alert-circle',
        },
        refund_pending: {
          text: 'Estorno pendente',
          color: 'blue-grey',
          icon: 'mdi-swap-horizontal',
        },
        'null': {
          text: 'error',
          color: 'error',
          icon: 'mdi-close',
        },
        'undefined': {
          text: 'error',
          color: 'error',
          icon: 'mdi-close',
        },
        '': {
          text: 'error',
          color: 'error',
          icon: 'mdi-close',
        },
      },
      headers: [
        { text: '#', value: 'id', sort: 'desc' },
        { text: 'Gerado em', value: 'created_at' },
        { text: 'Cliente', value: 'client_name' },
        { text: 'Tipo', value: 'pix_origin', sortable: false },
        { text: 'Gerado por', value: 'created_by_name' },
        { text: 'Expiração', value: 'due_date' },
        { text: 'Pago em', value: 'payment_date' },
        { text: 'Valor', value: 'total_amount' },
        { text: 'Chave da empresa', value: 'company_key' },
        // { text: 'Tipo local', value: 'solution' },
        { text: 'Módulo', value: 'place_name' },
        { text: 'Status ', value: 'pix_status' },
        { text: 'Ações', value: 'actions', sortable: false },
      ],
      origins_map: {
        link_cliente: { text: 'Link cliente', color: 'purple' },
        cobranca_link_cliente: { text: 'Cobrança (link cliente)', color: 'deep-purple' },
        cobranca: { text: 'Cobrança', color: 'indigo' },
        pedido: { text: 'Pedido', color: 'teal' },
        avulso: { text: 'Avulso', color: 'blue-grey' },
      },
      comp_keys_map: {...gateway_keys},

      local_filter: {},

      saving: false,
      verifying: false,

      dialog_pix: {
        show: false,
        qr_code: null,
        qr_code_text: null,
        id: null,
        gateway_provider: null,
      }
    }
  },
  methods: {
    handleDoneNewPixCobranca() {
      this.dialog_new_pix_cobranca = false
      this.getPix()
    },
    mapColor(item){
      return this.statuses_map[item.pix_status] ? this.statuses_map[item.pix_status]?.color : ''
    },
    mapIcon(item){
      return this.statuses_map[item.pix_status] ? this.statuses_map[item.pix_status]?.icon : ''
    },
    verifyPix(pix){
      // fazer request para grpc endpoint de verify e retornar o novo pix_status
      if (pix && pix.id){
        this.verifying = true
        Api.Pix.verify(pix.id).then(r=>r.data).then(d=>{
          if (d.pix_status != pix?.pix_status){
            alert('Pix foi atualizado! A página será recarregada para atualizar os dados')
            this.$emit('pixGenerated', d)
          } else {
            alert('Pix sem atualização!')
          }
        }).finally(() => {
          this.verifying = false
        })
      }
    },
    cancelPix(pix){
      this.swallConfirmation({
        title: 'Deseja cancelar o pix?',
        icon: 'question',
      }).then( confirmed =>{
        if (confirmed ) {
          if (pix && pix.id && ['pending', 'pendingv'].includes(pix.pix_status)){
            this.saving = true
            Api.Pix.cancel(pix.id).then(r=>r.data).then(d=>{
              console.log(d)
              this.all_pix = this.all_pix.map(p => p.id == pix.id ? {...p, pix_status: d.pix_status} : p)
            }).finally(() => {
              this.saving = false
            })
          }
          
        }
      })
      

    },
    handleDoneFilter(e) {
      this.local_filter = { ...e }
      this.pagination.page = 1
      this.getPix(e)

    },
    pixDialog(pix) {
      let { id, qr_code, qr_code_text, gateway_provider, total_amount, due_date, pix_status } = pix
      this.dialog_pix = { ...this.dialog_pix, show: true, id, qr_code, qr_code_text, gateway_provider, total_amount, due_date, pix_status }
    },
    closePixDialog() {
      this.dialog_pix.show = false
      this.dialog_pix.qr_code = null
      this.dialog_pix.qr_code_text = null
      this.dialog_pix.id = null
      this.dialog_pix.gateway_provider = null
    },
    pixCopy(pix) {
      if (pix && pix.qr_code_text) {
        navigator.clipboard.writeText(pix.qr_code_text);
        alert("Pix copiado!");
      } else {
        alert('Erro. Esse pix não possui o "copia e cola".');
      }
    },
    sharePixUrl(pix) {
      if (pix && pix.gateway_id) {
        let url = ''
        if(document.location.hostname == 'localhost'){
          url = document.location.host + '/api/v1/pix_share/' + pix.gateway_id
        }else{
          url = (process.env.VUE_APP_PIX_SHARE_URL || process.env.VUE_APP_AUTH0_AUDIENCE) + '/api/v1/pix_share/' + pix.gateway_id
        }
        navigator.clipboard.writeText(url);
        alert("Link copiado!\nAgora é só enviar para o seu cliente esse link!");
      } else {
        alert('Erro. Esse pix não possui o registro na "Shipay".');
      }
    },
    showPix(pix) { },
    refundPix(pix) {
      let c = confirm('Deseja estornar valor para o cliente?')
      if (c) {
        let { id, total_amount } = pix
        let obj = { id, refund_value: total_amount }

        this.saving = true
      }
    },
    getPix(filters){
      const { sortBy, sortDesc, page, itemsPerPage } = this.pagination
      let params = {
        page,
        limit: itemsPerPage,
        sort_field: sortBy[0]? sortBy[0] : null,
        sort_dir: sortBy[0]? (sortDesc[0]? 'desc' : 'asc') : null,
        modality_ids: [this.activeModalityId],
      }
      if (filters || this.local_filter) {
        params = {
          ...params,
          ...(filters || this.local_filter),
        }
      }
      this.filters = {...params}
      
      this.indexPix(params)
    },
    indexPix(params) {
      this.loading = true
      Api.Pix.index(params).then(r => r.data).then(d => {
        this.total_value = Number(d.total_value || 0)
        this.total_pix = d.total
        this.all_pix = d.data
      }).finally(() => {
        this.loading = false
      })
    },
  },
  watch: {
    activeModalityId() {
      this.pagination.page = 1
      this.getPix()
    },
    pagination: {
      deep: true,
      handler(nv) {
        if (!this.loaded_filter && nv.page != 1) {
          this.getPix()
        }
      },
    },
  },
}
</script>
